import React, { Component } from "react";
import { connect } from "react-redux";
import ReactPlayer from "react-player";
import moment from "moment";
import styled from "styled-components";
import Selectors from "../Selectors";
import ActionCreator from "../ActionCreator";
import * as Widget from "./Widget2";
import Image from "./Image";

class NewStoreSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      storeDetail: null
    };
  }
  componentDidMount() {
    let { store, appActions } = this.props;
    appActions
      .fetchStoreById(store.id)
      .then(data => this.setState({ storeDetail: data }))
      .catch(err => console.warn(err));
  }

  render() {
    let { store, navActions } = this.props;
    let { storeDetail } = this.state;

    console.warn("DBG", store);

    return (
      <Wrapper onClick={() => navActions.push(`/store/?id=${store.id}`)}>
        <Widget.SectionTitle haveMarginBottom={true}>
          最新店家
        </Widget.SectionTitle>
        <ItemContainer>
          <div className="video">
            <ReactPlayer
              key={"video"}
              url={this._getStoreVideoLink(store)}
              width={"100%"}
              height={"100%"}
            />
          </div>
          <div className="content">
            <div className="name">{store.name}</div>
            <Widget.Row
              align="center"
              css={`
                @media screen and (max-width: 700px) {
                  padding: 6px;
                }
                @media screen and (max-width: 500px) {
                  flex-wrap: wrap;
                  justify-content: center;
                }
              `}
            >
              <Widget.Col justify="space-between">
                <div className="text">
                  {storeDetail &&
                    (storeDetail.description.length <= 141
                      ? storeDetail.description
                      : storeDetail.description.slice(0, 142))}
                </div>
                <div className="date">
                  {moment(store.created).format("MMMM YYYY")}
                </div>
              </Widget.Col>

              <div className="logo">
                <Image
                  background
                  src={store.image}
                  css="margin-left: 20px; width: 120px; height: 120px;"
                />
              </div>
            </Widget.Row>
          </div>
        </ItemContainer>
      </Wrapper>
    );
  }

  _getStoreVideoLink = store => {
    try {
      let link = JSON.parse(store.data);
      return link["video_link"];
    } catch (err) {
      console.warn(err);
    }
  };
}

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0px 30px;
  cursor: pointer;
`;

const ItemContainer = styled.div`
  max-width: 1036px;
  width: 100%;
  min-height: 300px;

  box-shadow: 0 5px 20px 1px rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  padding: 25px 30px;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;

  :active {
    position: relative;
    top: 1px;
    left: 1px;
  }

  & .video {
    width: 305px;
    height: 250px;

    @media screen and (max-width: 768px) {
      width: 244px;
      height: 200px;
    }

    @media screen and (max-width: 700px) {
      width: 100%;
      height: 190px;
    }
  }

  & .content {
    margin-left: 25px;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;

    @media screen and (max-width: 700px) {
      margin-left: 0px;
    }
  }

  & .name {
    margin-bottom: 30px;
    line-height: 20px;
    letter-spacing: 0.63px;
    font-size: 22px;
    color: #4e4e4e;

    @media screen and (max-width: 800px) {
      margin-bottom: 20px;
    }

    @media screen and (max-width: 700px) {
      margin-top: 20px;
      text-align: center;
    }
  }

  & .logo {
  }

  & .text {
    margin-bottom: 80px;
    line-height: 20px;
    letter-spacing: 0.4px;
    font-size: 14px;
    color: #4e4e4e;

    @media screen and (max-width: 900px) {
      margin-bottom: 60px;
    }

    @media screen and (max-width: 800px) {
      margin-bottom: 10px;
    }
  }

  & .date {
    line-height: 20px;
    letter-spacing: 0.4px;
    font-size: 14px;
    color: #b4b9c4;
  }

  @media screen and (max-width: 700px) {
    flex-direction: column;
    padding: 6px;
  }
`;

export default connect(
  (state, ownProps) => ({
    // id 8 is prod env need "Stopover" store data
    store:
      Selectors.getStoreList(state).results.find(store => store.id === 8) ||
      Selectors.getStoreList(state).results[0]
  }),
  ActionCreator
)(NewStoreSection);
